import { call, put, takeEvery } from 'redux-saga/effects'
import { userPharmacyLogin, userPharmacyLoginSuccess, userPharmacyLoginFailed } from './slice'
import { API } from 'src/pharmacy/services/index'

function* loginPharmacy({ payload }) {
  try {
    const response = yield call(API.authApi.loginApiPharmacy, payload)
    if (
      response?.status === 200 &&
      response?.data &&
      response?.data?.code === 0 &&
      response?.data?.error === false
    ) {
      yield put(userPharmacyLoginSuccess({ payload: response?.data }))
    } else {
      yield put(userPharmacyLoginFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(userPharmacyLoginFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(userPharmacyLogin, loginPharmacy)
}

export default authSaga
